export const resourceAddress = process.env.REACT_APP_RESOURCES_ADDRESS;
export const azureRegion = '';
export const appInsightsInstrumentationKey = '';
export const localSiteHost = process.env.REACT_APP_IDENTITY_ADDRESS;
export const cbrnResponderCredentialsLoginProviderName = 'loginWithCbrnResponderCredentials';
export const externalLoginProviderName = "loginWithExternalProvider"; 


export const makeRandomString = () => {
    const maxLength = 36;
    let length = Math.round(Math.random() * maxLength);
    return (Math.random() + 1).toString(maxLength).substring(length);
}